import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormField } from '../../../../../../global/form/form-field/form-field';
import { LABEL, URL } from '../../../../../../../modules/event-links/config';
import { LinkFormViewModel } from './link-form.viewmodel';

export const LinkForm = observer((props: {vm: LinkFormViewModel}) => {
    const { formatMessage } = useIntl();
    const { vm } = props;


    const linkLabel = vm.getFieldByKey(LABEL);
    const linkLabelText = formatMessage(vm.getFieldConfigByKey(LABEL).labelDescriptor);

    const linkUrl = vm.getFieldByKey(URL);
    const linkUrlLabel = formatMessage(vm.getFieldConfigByKey(URL).labelDescriptor);

    return (
        <div className='p-20px'>
            <FormField label={linkLabelText}>
                <div className='flex'>
                    <input
                        className='oe-form-field__control'
                        onBlur={vm.setValueTouched.bind(vm, LABEL)}
                        value={linkLabel.value as string || ''}
                        type='text'
                        onChange={e => vm.setFieldValueByKey(LABEL, e.target.value)}
                    />
                </div>
                <span className='oe-form-field__error'>
                    {
                        !linkLabel.valid && linkLabel.touched &&
                        <FormattedMessage values={{ fieldName: linkLabelText }} {...linkLabel.validationMessage} />
                    }
                </span>
            </FormField>
            <FormField label={linkUrlLabel} className='m-bottom-0px'>
                <div className='flex'>
                    <input
                        className='oe-form-field__control'
                        onBlur={vm.setValueTouched.bind(vm, URL)}
                        value={linkUrl.value as string || ''}
                        type='text'
                        onChange={e => vm.setFieldValueByKey(URL, e.target.value)}
                    />
                </div>
                <span style={{height: '20px'}} className='oe-form-field__error'>
                    {
                        !linkUrl.valid && linkUrl.touched &&
                        <FormattedMessage values={{ fieldName: linkUrlLabel }} {...linkUrl.validationMessage} />
                    }
                </span>
            </FormField>
        </div>
    );
});
